import { render, staticRenderFns } from "./BandejaLinkSeguimientoPTIComponente.vue?vue&type=template&id=ae5e65e6&scoped=true"
import script from "./BandejaLinkSeguimientoPTIComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkSeguimientoPTIComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5e65e6",
  null
  
)

export default component.exports